import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SelectLetterTargetsModalComponent } from './select-letter-targets-modal.component';

import { GroupMember } from '@schoolbelle/api/group-member';
import { GroupService } from '@schoolbelle/api/group';
import { LetterTargetService, Target, SimplifiedTarget } from '@schoolbelle/api/letter-target';
import { take, tap, share, switchMap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class SelectLetterTargetsModalService {
  constructor(
    private modalService : BsModalService,
    // private loadingService: LoadingService,
    private groupService: GroupService,
    private target: LetterTargetService,
  ){
  }
  prepare (targets:Target[] = []) {
    let root_group_id = this.groupService.currentGroup.sid || this.groupService.currentGroup.gid;
    return this.target.checkIn(root_group_id, undefined, true)
    .pipe(
      tap(()=>this.target.load(targets)),
      share(),
      tap(null, e=>console.error(e)),
    );

  } 
  open(targets:Target[] = [], tab:'studentparent'|'faculty' = 'studentparent'):Observable<{targets:Target[], simplifiedTargets:SimplifiedTarget[], members:GroupMember[]}> {
    const checkin = this.prepare(targets)
    
    return checkin.pipe(
      switchMap(()=>{
        const modal:BsModalRef = this.modalService.show(SelectLetterTargetsModalComponent, {class:'modal-xl', initialState:{tab}});
        return modal.content.action.pipe(take(1)) // as Observable<{targets:Target[], simplifiedTargets:SimplifiedTarget[], members:GroupMember[]}>
      }),
      map((bool:boolean)=>{
        const targets = this.target.targets;        
        const simplifiedTargets = this.target.simplifiedTargets;
        return bool ? {
          targets,
          simplifiedTargets,
          // deprecated 
          // targets:this.target.supplyTargetsWithCompatibilityProperties(targets),
          // simplifiedTargets: this.target.supplyTargetsWithCompatibilityProperties(simplifiedTargets) as Array<SimplifiedTarget>,
          // deprecated 
          members:this.target.getMembersInTargets(targets),
        } : null
      })
    )
  }
}
